import { render, staticRenderFns } from "./testStat.vue?vue&type=template&id=4c2e022e&scoped=true&"
import script from "./testStat.vue?vue&type=script&lang=js&"
export * from "./testStat.vue?vue&type=script&lang=js&"
import style0 from "./testStat.vue?vue&type=style&index=0&lang=css&"
import style1 from "./testStat.vue?vue&type=style&index=1&id=4c2e022e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2e022e",
  null
  
)

export default component.exports